import styled from 'styled-components';

interface ITitle {
  weight?: string;
}

export const Title = styled.p<ITitle>`
  font-size: 24px;
  color: #42434a;
  font-weight: ${(props) => (props.weight ? props.weight : 'normal')};
`;

interface IParagphElement {
  marginBottom?: number;
  marginTop?: number;
}

export const ParagphElement = styled.p<IParagphElement>`
  color: #6e6e6e;
  font-size: 14px;
  margin-bottom: ${(props) => (props.marginBottom ? props.marginBottom : 5)}px;
  margin-top: ${(props) => (props.marginTop ? props.marginTop : 0)}px;
`;

export const CaptchContainer = styled.div`
  padding-bottom: 16px;
  grid-column: span 2;

  @media only screen and (max-width: 500px) {
    grid-column: unset;
  }
`;
